<template>
  <div :key="refreshKey">
    <Navbar/>
    <router-view/>
  </div>
</template>



<script setup>
import { ref, provide } from 'vue'
import Navbar from '@/components/Navbar'

const refreshKey = ref(0)
provide('refreshKey', refreshKey)
</script>


<style>
html, body {
    margin: 0;
    padding: 0;
    height: 100vh; /* 设置为视口高度 */
    min-height: 100vh;
    overflow: hidden; /* 防止body滚动 */
}

#app {
    height: 100%;
    min-height: 100%;
    overflow: hidden; /* 容器内的滚动由子组件控制 */
}

::-webkit-scrollbar{
  width: 1px;
  position: absolute;
}

::-webkit-scrollbar-thjumb{
  background: #1890ff;
}

::-webkit-scrollbar-track{
  background:#ddd;
}

</style>
